'use client';
import React__default, { createContext, useContext, useMemo } from 'react';
import { ComponentsProvider } from './components.mjs';
import { OverridesProvider } from './overrides.mjs';

const LiveblocksUIConfigContext = createContext({});
function useLiveblocksUIConfig() {
  return useContext(LiveblocksUIConfigContext);
}
function LiveblocksUIConfig({
  overrides,
  components,
  portalContainer,
  children
}) {
  const liveblocksUIConfig = useMemo(
    () => ({ portalContainer }),
    [portalContainer]
  );
  return /* @__PURE__ */ React__default.createElement(LiveblocksUIConfigContext.Provider, {
    value: liveblocksUIConfig
  }, /* @__PURE__ */ React__default.createElement(OverridesProvider, {
    overrides
  }, /* @__PURE__ */ React__default.createElement(ComponentsProvider, {
    components
  }, children)));
}

export { LiveblocksUIConfig, useLiveblocksUIConfig };
//# sourceMappingURL=config.mjs.map
